/* tslint:disable */
/* eslint-disable */
/**
 * external-information-requests
 * Medicaid Pending document requests to family members, with the staff workspace and the family portal
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const MedicaidCaseStatus = {
    Draft: 'draft',
    Open: 'open',
    Paused: 'paused',
    Closed: 'closed',
} as const;
export type MedicaidCaseStatus = typeof MedicaidCaseStatus[keyof typeof MedicaidCaseStatus];


export function instanceOfMedicaidCaseStatus(value: any): boolean {
    for (const key in MedicaidCaseStatus) {
        if (Object.prototype.hasOwnProperty.call(MedicaidCaseStatus, key)) {
            if (MedicaidCaseStatus[key as keyof typeof MedicaidCaseStatus] === value) {
                return true;
            }
        }
    }
    return false;
}

export function MedicaidCaseStatusFromJSON(json: any): MedicaidCaseStatus {
    return MedicaidCaseStatusFromJSONTyped(json, false);
}

export function MedicaidCaseStatusFromJSONTyped(json: any, ignoreDiscriminator: boolean): MedicaidCaseStatus {
    return json as MedicaidCaseStatus;
}

export function MedicaidCaseStatusToJSON(value?: MedicaidCaseStatus | null): any {
    return value as any;
}

export function MedicaidCaseStatusToJSONTyped(value: any, ignoreDiscriminator: boolean): MedicaidCaseStatus {
    return value as MedicaidCaseStatus;
}

